import { memo } from "react";

const MenuIcon = ({ onClick, className, size = 28 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 28 28"
      onClick={onClick}
      className={className}
    >
      <path
        d="M5 8h18M5 14h18M5 20h18"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default memo(MenuIcon);
